<template>
  <div class="wrapper">
    <div class="topo-header centro">
      <botao-voltar nomeRota="Perguntas" />
      <h1>{{ perguntaForm.id ? "Editar" : "Nova" }} Pergunta</h1>
    </div>
    <div class="tab-dados-basicos">
      <div class="form centro">
        <MsgErroFormularios
          v-if="erro && msgErros"
          :mensagens="msgErros"
          :erro="erro"
          @fechar-erro="fecharErro"
        />
        <p>Os campos com asterisco (*) são de preenchimento obrigatório.</p>
        <form @submit.prevent="enviarForm">
          <div class="caixa-form item">
            <div class="item">
              <label><b>{{ possuiAsterisco("Texto da Pergunta:") }}</b></label>
              <textarea
                rows="5"
                placeholder="Digite o enunciado da pergunta"
                v-model="perguntaForm.texto"
              ></textarea>
            </div>
              <div class="ativo">
                <label for="ativo">Ativo</label>
                <input id="ativo" type="checkbox" v-model="perguntaForm.ativo">
              </div>
              <br>
            <div class="bt-salvar">
              <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                <p id="conteudo-botao">
                  {{ perguntaForm.id ? "Atualizar" : "Criar" }}
                </p>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="js">

import PerguntaApi from "../../services/PerguntaApi";
import BotaoVoltar from "../../components/BotaoVoltar.vue";
import MsgErroFormularios from "../MsgErroFormularios";

export default {
    name: "PerguntaForm",
    props: {
        pergunta: {
            type: Object,
            required: false,
        },
    },
    components: {
        BotaoVoltar,
        MsgErroFormularios,
    },
    data() {
        return {
            erro: false,
            msgErros: {
                texto: '',
                ativo: '',
                default: '',
            },
            perguntaForm: this.pergunta
                ? { ...this.pergunta }
                : {
                    id: null,
                    texto: "",
                    ativo: true,
                },
        };
    },
    created() {
        this.perguntaApi = new PerguntaApi();
    },
    methods: {
        fecharErro() {
            this.erro = false;
        },
        async enviarForm() {
            if (!this.perguntaForm.texto || this.perguntaForm.texto.trim() === '') {
                this.msgErros.texto = "O texto da pergunta não pode ficar em branco.";
                this.erro = true;
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }

            try {
                this.erro = false;
                const dataPergunta = await this.perguntaApi.setPergunta(
                    this.perguntaForm
                );
                
                this.$router.push({
                    name: "PerguntaShow",
                    params: { id: dataPergunta.id },
                });

            } catch (err) {
                console.error(err);
                this.erro = true;
                const { response } = err;
                if (response && response.data) {
                    this.msgErros = response.data;
                } else {
                    this.msgErros.default = "Houve um erro ao salvar o registro. Por favor, tente novamente.";
                }
            }
        },
        possuiAsterisco(texto) {
            var texto_final = "* " + texto;
            return texto_final;
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 1.5rem;
}
input[type="checkbox"] {
  transform: scale(1.5); /* aumenta 50% */
  margin: 0 5px;         /* ajusta espaço do lado */
}
.ativo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 2rem;
}
.caixa-form {
  background-color: #f0f0f0;
  padding: 1.5rem;
  border-radius: 8px;
}
.item {
  margin-bottom: 1.5rem;
}
label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}
textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: inherit;
  font-size: 1rem;
}
.checkbox-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.bt-salvar button {
  padding: 0.75rem 1.5rem;
  background-color: #005516;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}
.bt-salvar button:hover {
  background-color: #003d0f;
}
</style>
